import React from 'react';
import {Row, Column} from '../../global/grid/grid';

import { Text } from './styled-components';

const TextBlock = ({data}) => {
  return (
    <div>
        <Row margins={true}>
          <Column cw={6} offset={3} tcw={8} tOffset={2}>
            <Text>
            { data.text }
            </Text>
          </Column>
        </Row>
    </div>
  )
}

export default TextBlock;



// WEBPACK FOOTER //
// ./src/components/modules/TextBlock/TextBlock.js